module.exports = __webpack_public_path__ + "img/13_42.a7d49b06.png";